import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { COMMODITY_DATA } from "../mock";

const BRAND = "Leslie West Africa Trading Company";

const titleFor = (path) => {
  const seg = path.split("/").filter(Boolean);
  if (seg[0] === "trading") return `${COMMODITY_DATA[seg[1]]?.label || "Coffee"} & Trading`;
  if (seg[0] === "origins") return "Origins";
  if (seg[0] === "wholesale") return "Wholesale Enquiry";
  if (seg[0] === "spec") return "Lot Spec Sheet";
  if (seg[0] === "offer") return "Your Offer";
  if (seg[0] === "security") return "Security & Consulting";
  if (seg[0] === "admin") return "Trade Desk";
  return null;
};

export function usePageTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const t = titleFor(pathname);
    document.title = t ? `${t} · ${BRAND}` : BRAND;
  }, [pathname]);
}
